import { DataTable, List, SearchInput } from "@/components/admin";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { useRecordContext } from "ra-core";
import type { Vendor } from "../types";

const StatusCell = () => {
    const record = useRecordContext<Vendor>();
    if (!record) return null;
    return (
        <Badge variant="secondary">
            Pending Approval
        </Badge>
    );
};

export const VendorApprovalQueue = () => {
    return (
        <List 
            title="Vendor Approval Queue" 
            filterDefaultValues={{ status: 'pending_approval' }}
            filters={[<SearchInput key="q" source="q" alwaysOn />]}
            className="p-6"
        >
            <Card className="border-none shadow-sm overflow-hidden">
                <DataTable rowClick="show">
                    <DataTable.Col source="name" label="Vendor Name" className="font-bold" />
                    <DataTable.Col source="contact_person" label="Contact Person" />
                    <DataTable.Col source="category" label="Category" />
                    <DataTable.Col label="Status">
                        <StatusCell />
                    </DataTable.Col>
                    <DataTable.Col source="created_at" label="Applied On" />
                    <DataTable.Col source="email" label="Email" className="text-xs text-slate-500" />
                </DataTable>
            </Card>
        </List>
    );
};
